import React from 'react';


const EyeIcon = () => (
  <svg
    id="eye-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--icon-color)"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="eye-icon"
  >
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export default EyeIcon;
